import React from 'react';
import { Tooltip as MUITooltip } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

const StyledTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: '160px',
    textAlign: 'center',
  },
}))(MUITooltip);

const Tooltip = ({ children, text }) => (
  <StyledTooltip title={text} placement="top" arrow>
    {children}
  </StyledTooltip>
);

export default Tooltip;
